import { AxiosResponse } from "axios";
import { Canal } from "../interfaces/canal.interface";
import { BACKEND_ENDPOINT, CANAL } from "../utils/constants";

export const getCanalFromBackend = (apiRequest: any) => {
    return new Promise<Canal[]>((resolve, reject) => {
        const url = BACKEND_ENDPOINT() + CANAL;
        const method = 'GET';
        const options = {
            url,
            method
        }
        apiRequest(options)
            .then((response: AxiosResponse) => resolve(response.data))
            .catch((error : any) => reject(error));
    });
}
